import { css } from "@emotion/react";

export const styles = {
  group: css`
    display: flex;
    width: 100%;
    flex-direction: column;
    align-items: start;
    gap: var(--spacing-16);
    > :last-of-type {
      margin-bottom: var(--spacing-8);
    }
  `,
  itemWrapper: css`
    display: flex;
    align-items: center;
    justify-content: start;
    gap: var(--spacing-16);
    .kit-Input {
      width: 80px;
    }
  `
};
